import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.LINKS_START_LOADING,
    success: AppConstants.LINKS_SEARCH_SUCCESS,
    fail: AppConstants.LINKS_FAIL
};

const LinksActions = {
    getListLinks(params, callback, events = defEvents) {
        if (events.before) {
            dispatch({
                type  : events.before
            });
        }

        api.searchLinks(params)
            .then(data => {
                if (events.success) {
                    dispatch({
                        type: events.success,
                        items: data.response || {}
                    });
                }

                callback && callback(data.response);
            })
            .catch(err => {
                console.error('Error fetching links:', err);
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
                callback && callback({ items: [], total: 0, page: 1 });
            });
    },

    saveLinkPresets(params) {
        return api.saveLinkPresets(params);
    }
};

export default LinksActions;
